import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const TipoSepulturaList = props => <DefaultDataTable data={props} />;
